import FundUnicefKrTemplate from '@/page-blocks/about-us/clear/fund/unicef-kr/FundUnicefKrTemplate';
import ReportKorea2025 from '@/page-blocks/about-us/clear/fund/unicef-kr/report.korea_2025';
import { PageProps } from 'gatsby';
import React from 'react';

const FundUnicefKrIndex: React.FC<PageProps> = (props) => (
  <FundUnicefKrTemplate year={2025} {...props}>
    <ReportKorea2025 />
  </FundUnicefKrTemplate>
);

export default FundUnicefKrIndex;
